import React from "react";
import {
  Box,
  Container,
  List,
  ListItem,
  Typography,
  IconButton,
  Divider,
  styled,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { motion } from "framer-motion";
import BgTitle from "components/title/BgTitle";

const StyledListItem = styled(ListItem)(({ theme }) => ({
  padding: "16px",
  "&:active": {
    backgroundColor: "#f5f5f5",
  },
}));

const LinkButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: "#f5f7fa",
  color: "#0c4d96",
  padding: "8px",
  "&:hover": {
    backgroundColor: "#e8eef7",
  },
}));

const StyledDivider = styled(Divider)(({ theme }) => ({
  margin: "0 16px",
  borderColor: "#e0e0e0",
}));

const EmployeeLinksComponent = () => {
  const { t } = useTranslation();
  const links = t("employee_links", { returnObjects: true });

  return (
    <Container
      maxWidth="sm"
      sx={{
        py: 3,
        px: 2,
      }}
    >
      <Box sx={{ mb: 3 }}>
        <BgTitle text={t("employee_headline")} />
      </Box>

      <Box
        sx={{
          bgcolor: "#F5F5F5",
          borderRadius: "8px",
          overflow: "hidden",
        }}
      >
        <List disablePadding>
          {links.map((link, index) => (
            <React.Fragment key={index}>
              <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.2, delay: index * 0.05 }}
              >
                <StyledListItem
                  component={motion.div}
                  whileTap={{ backgroundColor: "#F5F5F5" }}
                  onClick={() =>
                    window.open(link.link, "_blank", "noopener,noreferrer")
                  }
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    cursor: "pointer",
                    backgroundColor: "white",
                  }}
                >
                  <Box sx={{ flex: 1, mr: 2 }}>
                    <Typography
                      variant="subtitle1"
                      sx={{
                        fontWeight: 600,
                        color: "#0c4d96",
                        fontSize: "0.95rem",
                        lineHeight: 1.4,
                      }}
                    >
                      {link.title}
                    </Typography>
                  </Box>

                  <LinkButton size="small" edge="end" aria-label="open link">
                    <OpenInNewIcon sx={{ fontSize: 20 }} />
                  </LinkButton>
                </StyledListItem>
              </motion.div>
              {index < links.length - 1 && <StyledDivider />}
            </React.Fragment>
          ))}
        </List>
      </Box>
    </Container>
  );
};

export default EmployeeLinksComponent;
